import { useMemo } from 'react';
import { keepPreviousData } from '@tanstack/react-query';

import { Environment } from '@playq/octopus-common';
import { ClusterizationTask, ClusterizationTaskId } from '@playq/services-beetle';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const retrieveTaskKeys = ['retrieve', 'task'];
export const useRetrieveTask = (
  id: ClusterizationTaskId,
  env: Environment = Environment.Live,
  options?: IUseQueryOptionsExtended<ClusterizationTask | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => retrieveTaskKeys.concat(id?.serialize(), env), [env, id]);
  const res = useEitherQuery(keys, () => services2.audienceRequestsClusterizationService.retrieveTask(id, env), {
    placeholderData: keepPreviousData,
    ...options,
  });

  const isLoading = res.isLoading && res.fetchStatus !== 'idle';
  return { ...res, isLoading };
};
